var presentAfterpay = presentAfterpay || {};
var presentClearpay = presentClearpay || {};

(function ($) {
  Drupal.behaviors.skuListV2 = {
    $productFull: $(),
    attach: function (context) {
      var self = this;
      var $skuLists = $('.js-sku-list--v2', context);

      self.$productFull = $('.js-product-full', context);

      if (self.attached) {
        return;
      }
      self.attached = true;

      $skuLists.each(function () {
        var $template = $(this);
        var $skuListItems = $template.find('.js-sku-list-item');
        var skuId = $template.closest('.js-product').data('sku-base-id');
        var $skuListInput = $template.find('.js-sku-list-item-input');
        var $curentSize = $skuListInput.filter('[data-sku-base-id=' + skuId + ']').closest($skuListItems);
        self.selectSize($curentSize, false);

        if ($skuListInput.length === 1) {
          $skuListInput.addClass('hidden');
        }

        $skuListItems.once().on('click keydown', function (e) {
          var $item = $(this);
          if (e.key === 'Enter' || e.type === 'click') {
            self.selectSize($item, true);
          }
        });
      });
    },
    waitForInstallmentLibPay: false,
    installmentsPrice: function ($skuPrice, $productEl) {
      var self = this;
      var amount;
      var isAfterpayReady = $.isEmptyObject(presentAfterpay) === false && typeof presentAfterpay === 'function';
      var isClearpayReady = $.isEmptyObject(presentClearpay) === false && typeof presentClearpay === 'function';
      var $installmentsParagraph = self.$productFull.length > 0 ? self.$productFull.find('.afterpay-paragraph') : $productEl.find('.afterpay-paragraph');

      if ($skuPrice.length < 1) {
        return;
      }
      if (!isAfterpayReady && !isClearpayReady && !self.waitForInstallmentLibPay) {
        self.waitForInstallmentLibPay = true;
        // Wait for loaded event.
        $(document).on('installments-lib-ready', function() {
          self.installmentsPrice($skuPrice, $productEl);
        });
      }
      amount = $skuPrice.html().replace(/[^\d]/g, '');

      if ($installmentsParagraph.length > 0) {
        $installmentsParagraph.remove();
      }

      if (isAfterpayReady && amount) {
        presentAfterpay?.afterpayConfig(amount);
      }

      if (isClearpayReady && amount) {
        presentClearpay?.clearpayConfig(amount);
      }
    },
    selectSize: function ($item, userAction) {
      var self = this;
      var skuBaseId = $item.data('sku-base-id');
      var $skuPrice = $item.find('.js-sku-price');
      var $productEl = $item.closest('.js-product');
      var $allSkuInputs = $('.js-sku-list-item-input[data-sku-base-id]');
      var $matchingInputs;

      if (!skuBaseId) {
        return;
      }

      userAction && $productEl.trigger('product.skuSelect', [skuBaseId]);

      $allSkuInputs.removeClass('checked').prop('checked', false);

      $matchingInputs = $('.js-sku-list-item-input[data-sku-base-id="' + skuBaseId + '"]');
      $matchingInputs.addClass('checked').prop('checked', true);

      self.installmentsPrice($skuPrice, $productEl);
    },

    attached: false
  };
})(jQuery);
